(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8660,1917],{

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 92868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SmootherContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (SmootherContext);

/***/ }),

/***/ 69177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Testimonial_v1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/Title.jsx
var Title = __webpack_require__(93264);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(50067);
// EXTERNAL MODULE: ./components/Img.jsx
var Img = __webpack_require__(68019);
// EXTERNAL MODULE: ./styles/globalStyleVars.js
var globalStyleVars = __webpack_require__(68312);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/react-modal-video/css/modal-video.min.css
var modal_video_min = __webpack_require__(15371);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 24 modules
var Modal = __webpack_require__(82307);
// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/simplebar-react.esm.js + 1 modules
var simplebar_react_esm = __webpack_require__(14863);
// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/simplebar.min.css
var simplebar_min = __webpack_require__(202);
// EXTERNAL MODULE: ./node_modules/react-modal-video/lib/index.js
var react_modal_video_lib = __webpack_require__(61239);
// EXTERNAL MODULE: ./components/SmootherContext.jsx
var SmootherContext = __webpack_require__(92868);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/home/PopupV1.jsx













var PopupV1 = function PopupV1(_ref) {
  var show = _ref.show,
      handleClose = _ref.handleClose,
      no_img = _ref.no_img,
      item = _ref.item,
      title = _ref.title,
      description = _ref.description,
      data = _ref.data,
      subtitle = _ref.subtitle,
      video = _ref.video,
      direct_video = _ref.direct_video;
  var popupData = data;

  var _useState = (0,react.useState)(true),
      winWidth = _useState[0],
      setWinWidth = _useState[1];

  (0,react.useEffect)(function () {
    if (window.innerWidth > 767) {
      setWinWidth(true);
    } else {
      setWinWidth(false);
    }

    window.addEventListener("resize", function () {
      if (window.innerWidth > 767) {
        setWinWidth(true);
      } else {
        setWinWidth(false);
      }
    });
  }, []);

  var _useState2 = (0,react.useState)(true),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      videoId = _useState3[0],
      setVideo = _useState3[1];

  var modalRef = (0,react.useRef)(null);

  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
    setVideo('');
    handleClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledModal, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: show,
      item: item,
      onHide: handleCloseModal,
      backdrop: "static",
      keyboard: false,
      className: "gph_modal modal_video_popup popup-version-one",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(simplebar_react_esm/* default */.Z, {
        className: "main_scroll ",
        style: {
          height: '100vh'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
              className: 'for-close',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: handleCloseModal,
                className: "modal-close ",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  id: "Button_-_Close",
                  "data-name": "Button - Close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "44",
                  height: "44",
                  viewBox: "0 0 44 44",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Ellipse_18",
                    "data-name": "Ellipse 18",
                    fill: "none",
                    stroke: "#3c3c3b",
                    "stroke-width": "1",
                    opacity: "0.3",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Ellipse_19",
                    "data-name": "Ellipse 19",
                    fill: "none",
                    stroke: "#3c3c3b",
                    "stroke-width": "1",
                    strokeDasharray: "0 142",
                    opacity: '0',
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Group_18979",
                    "data-name": "Group 18979",
                    transform: "translate(-3149 -104.5)",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("line", {
                      id: "Line_4",
                      "data-name": "Line 4",
                      x2: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      "stroke-width": "1"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
                      id: "Line_3877",
                      "data-name": "Line 3877",
                      x1: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      "stroke-width": "1"
                    })]
                  })]
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "modal-data d-flex",
                children: popupData ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_modal_video_lib/* default */.Z, {
                  ref: modalRef,
                  channel: "youtube",
                  isOpen: video,
                  videoId: popupData,
                  onClose: handleCloseModal
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react_modal_video_lib/* default */.Z, {
                  ref: modalRef,
                  channel: "youtube",
                  isOpen: video,
                  videoId: popupData,
                  onClose: handleCloseModal
                })
              })
            })
          })]
        })
      })
    })
  });
};

var StyledModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PopupV1__StyledModal",
  componentId: "sc-1n1q7yo-0"
})([".modal-dialog{margin:0;}h4{letter-spacing:1.5px;}"]);
/* harmony default export */ var home_PopupV1 = (PopupV1);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/gsap/index.js
var gsap = __webpack_require__(62642);
;// CONCATENATED MODULE: ./components/Testimonial-v1.jsx



















var MyComponent = function MyComponent(_ref) {
  var _data$posts;

  var background = _ref.background,
      data = _ref.data;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_list = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;

  var _useState = (0,react.useState)(''),
      current = _useState[0],
      setCurrent = _useState[1];

  var handleSliderCurrent = function handleSliderCurrent() {
    setTimeout(function () {
      if (document.querySelector('.amenities__big .swiper-pagination-current')) {
        setCurrent(document.querySelector('.amenities__big .swiper-pagination-current').innerHTML);
      }
    }, 200);
  };

  var _useState2 = (0,react.useState)(false),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0,react.useState)(),
      popupId = _useState3[0],
      setPopupId = _useState3[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow(e) {
    setShow(true);
    setPopupId(e);
  };

  var location = (0,router.useRouter)();
  (0,react.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap/* gsap.to */.p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledComponent, {
    background: background,
    className: 'amenities  pb-200 pt-200 as-image-text-slider',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(home_PopupV1, {
      show: show,
      video: true,
      data: popupId,
      handleClose: handleClose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          sm: {
            span: 3
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title["default"], {
            noanim: true,
            margin: '0 0 40px 0',
            text: section_data === null || section_data === void 0 ? void 0 : section_data.subtitle
          }), section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-lag": '0.2',
            className: "slider-nav",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "hover testimonial-prev",
                id: 'testimonial-prev',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronLeft */.pjk, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  children: [current < 9 && 0, current + 1, /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: ["/", (section_list === null || section_list === void 0 ? void 0 : section_list.length) < 9 && 0, section_list === null || section_list === void 0 ? void 0 : section_list.length]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "hover testimonial-next",
                id: 'testimonial-next',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronRight */.fmn, {})
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          className: 'amenities__big',
          sm: {
            span: 4
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "amenities__big__slider",
            children: section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
              Swiper: true,
              modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_, swiper_esm/* EffectCreative */.gI],
              pagination: {
                // el: '.swiper-pagination',
                type: "fraction"
              },
              navigation: {
                prevEl: '.testimonial-next',
                nextEl: '.testimonial-next'
              },
              onBeforeInit: function onBeforeInit(swiper) {
                swiper.params.navigation.prevEl = '.testimonial-prev';
                swiper.params.navigation.nextEl = '.testimonial-next';
              },
              speed: 900,
              onSlideChange: function onSlideChange(s) {
                return handleSliderCurrent();
              },
              children: section_list === null || section_list === void 0 ? void 0 : section_list.map(function (e, index) {
                var _e$data, _e$images, _e$images$, _e$images2, _e$images2$;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                  children: e !== null && e !== void 0 && (_e$data = e.data) !== null && _e$data !== void 0 && _e$data.youtube_link ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "single",
                    onClick: function onClick() {
                      var _e$data2;

                      return handleShow(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.youtube_link);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "icon",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "80",
                        height: "80",
                        viewBox: "0 0 80 80",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                          id: "Mask_Group_392",
                          transform: "translate(-793 -3533)",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                            id: "Ellipse_604",
                            cx: "40",
                            cy: "40",
                            r: "40",
                            transform: "translate(793 3533)",
                            fill: "#fff"
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                            id: "Ellipse_606",
                            cx: "40",
                            cy: "180",
                            r: "40",
                            transform: "translate(793 3533)",
                            fill: "#3c3c3b"
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                            id: "Polygon_1",
                            d: "M9.168,1.248a1,1,0,0,1,1.664,0l8.131,12.2A1,1,0,0,1,18.131,15H1.869a1,1,0,0,1-.832-1.555Z",
                            transform: "translate(841 3563) rotate(90)",
                            fill: "#978C21"
                          })]
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "single__img testimonial-image",
                      children: (e === null || e === void 0 ? void 0 : e.images) && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                        alt: 'Shanta Securities Limited',
                        src: e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$ = _e$images[0]) === null || _e$images$ === void 0 ? void 0 : _e$images$.full_path
                      })
                    })]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "single",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "icon"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "single__img testimonial-image hoverNO",
                      children: (e === null || e === void 0 ? void 0 : e.images) && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                        alt: 'Shanta Securities Limited',
                        src: e === null || e === void 0 ? void 0 : (_e$images2 = e.images) === null || _e$images2 === void 0 ? void 0 : (_e$images2$ = _e$images2[0]) === null || _e$images2$ === void 0 ? void 0 : _e$images2$.full_path
                      })
                    })]
                  })
                }, index);
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          className: 'amenities__right',
          sm: 5,
          children: section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            Swiper: true,
            modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_, swiper_esm/* EffectCreative */.gI],
            initialSlide: 2,
            pagination: {
              el: '.swiper-pagination',
              type: "fraction"
            },
            navigation: {
              prevEl: '.testimonial-prev',
              nextEl: '.testimonial-next'
            },
            onBeforeInit: function onBeforeInit(swiper) {
              swiper.params.navigation.prevEl = '.testimonial-prev';
              swiper.params.navigation.nextEl = '.testimonial-next';
            },
            speed: 900,
            onSlideChange: function onSlideChange(s) {
              return handleSliderCurrent();
            },
            children: section_list === null || section_list === void 0 ? void 0 : section_list.map(function (e, index) {
              var _e$data3, _e$data4, _e$data5;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex",
                  children: [(0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.description), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "foot",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                      children: e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: e === null || e === void 0 ? void 0 : (_e$data5 = e.data) === null || _e$data5 === void 0 ? void 0 : _e$data5.subtitle
                    })]
                  })]
                })
              }, index);
            })
          })
        })]
      })
    })]
  });
};

var StyledComponent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Testimonial-v1__StyledComponent",
  componentId: "sc-10s1nfn-0"
})(["overflow:hidden;background-color:", ";.container{position:relative;.slider-nav{position:absolute;width:100%;z-index:3;padding-left:20px;bottom:0;left:0;ul{display:flex;li{height:40px;width:40px;background-color:black;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(2){padding:0 20px;height:auto;width:auto;background-color:transparent;}svg{color:#ffffff;z-index:2;}&:not(:nth-of-type(2)){cursor:pointer;}}}p{font-family:", ";font-size:24px;line-height:32px;color:#3C3C3B !important;span{font-size:16px;font-weight:500;line-height:24px;color:rgba(60,60,59,0.5);}}}.amenities__big{padding-right:40px;position:relative;&__slider{position:relative;background-color:#DDD;.shadow{position:absolute;bottom:-50px;right:calc(100% - 43px);z-index:2;width:120px;img{width:100%;object-fit:cover;}}.shadow-right{position:absolute;bottom:-52px;right:-49px;}.single{padding-top:calc(370 / 370 * 100%);position:relative;cursor:pointer;.icon{position:absolute;z-index:99;top:50%;left:50%;transform:translate(-50%,-50%);overflow:hidden;border-radius:50%;svg{#Ellipse_606,path{transition:1s all cubic-bezier(.25,.74,.22,.99);}}}.single__img{overflow:hidden;.global-image{transition:1s all cubic-bezier(.25,.74,.22,.99);transform:scale(1);}}&:hover{.single__img{.global-image{transform:scale(1.05);}}.icon{svg{#Ellipse_606{cy:40px;}path{fill:#fff;}}}}}}}&__thumb{width:30%;position:absolute;top:0;bottom:0;margin:auto;left:15px;height:fit-content;z-index:3;&__inner{.single{padding-top:100%;background-color:#EEE;}}}}.amenities__right{position:relative;.swiper-slide,.swiper-wrapper,.swiper{height:100%;}.flex{display:flex;height:100%;justify-content:space-between;flex-direction:column;}p{font-size:16px;line-height:24px;font-weight:500;color:rgba(60,60,59,0.5);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;white-space:normal;@media (max-width:1024px){display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;white-space:normal;}}h4{font-family:'Avenir';font-size:16px;font-weight:500;line-height:24px;margin-top:0px;margin-bottom:0px;color:#3C3C3B;}}@media (max-width:950px){.swiper-slide,.swiper-wrapper,.swiper{height:100%;}.amenities__big__slider{height:100%;.single{height:100%;}.icon{svg{height:50px;width:50px;}}}.slider-nav{li{&:not(:nth-of-type(2)){max-width:30%;}svg{max-width:100%;}}}.amenities__big{padding-right:15px !important;}.foot{margin-top:40px;}}@media (max-width:767px){.title{margin-bottom:0;}.amenities__big{&__thumb{height:150px;width:55%;bottom:-75px;div{height:100%;width:100%;}.single{padding:0 !important;}}}.amenities__right{margin-top:40px;padding-top:0;}.amenities__big__slider .icon svg{height:80px;width:80px;}.slider-nav{padding:0 !important;position:relative !important;margin:40px 0 !important;}}.swiper-pagination{opacity:0;visibility:hidden;}.shadow-left{position:absolute;left:0;top:10%;}.swiper-button-disabled{opacity:0.5 !important;}@media (max-width:767px){.title h2{margin-bottom:40px;}}"], function (p) {
  return p.background ? p.background : '#FFF';
}, globalStyleVars/* title */.TN);
/* harmony default export */ var Testimonial_v1 = (/*#__PURE__*/react.memo(MyComponent));

/***/ }),

/***/ 15371:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

}]);